module.exports = __webpack_public_path__ + "img/GWS19-49@2x-1793698374569.png";